module.exports = __webpack_public_path__ + "img/Frame 1889.7a533dcc.png";